define(function (require) {

    window.lpTag = window.lpTag || {};

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var agentLEManager = require('web-agent-utils/agentLEManager');

    lpTag.lpBaseInfoController = function () {
    };
    var lpBaseInfoController = lpTag.lpBaseInfoController;
    // All the public functions receive a "dataObject" - which they ignore.
    // The real data and synchronization is done via the model, in the CURRENT_POLLING_MODEL_LOCATION.

/////////////////////////////////// PUBLIC METHODS ///////////////////////////////////
    lpBaseInfoController.prototype.REQUEST_TIMEOUT = 60000;
    lpBaseInfoController.prototype.CURRENT_POLLING_MODEL_LOCATION = 'participants.infoServices.current';
    lpBaseInfoController.prototype.serviceNames = {
        agentSessionVisit: 'participants.infoServices.agentSessionVisit',
        visitMonitoring: 'participants.infoServices.visitMonitoring',
        consumerInfo: 'participants.infoServices.consumerInfo',
        goals: 'participants.infoServices.goals',
        engagements:'participants.infoServices.engagements',
        campaigns: 'participants.infoServices.campaigns',
        visitorBehavior: 'participants.infoServices.visitorBehavior',
        visitorProfile: 'participants.infoServices.visitorProfile',
        lob: 'participants.infoServices.lob',
        authenticated : 'participants.infoServices.authenticatedChat',
        window: 'participants.infoServices.window',
        appInstall: 'participants.infoServices.appInstall',
        engagementHistory: 'participants.infoServices.engagementHistory'
    };

    lpBaseInfoController.prototype.handleACRequestSuccess = function (model, data, name, getSingleObjectCallback, context, dataObject) {
        if (context) {
            context.responseCode = data.responseCode;
        }
        var dataToUse = {};
        if (data && data.body) {
            dataToUse = data.body;
        }
        dataToUse.dataObject = model.get(this.CURRENT_POLLING_MODEL_LOCATION);
        var singleProcessedObject = getSingleObjectCallback.call(context || this, dataToUse, name);
        if (singleProcessedObject && singleProcessedObject.id) {
            model.modify(name + '.data.' + singleProcessedObject.id,singleProcessedObject);
        }
    };

    lpBaseInfoController.prototype.getDataFromModelIfNotModified = function(model, data, name) {
        if (model && name && data && data.responseCode === 304) {
            return model.get(name + '.data.' + data.id);
        }
        return null;
    };

    lpBaseInfoController.prototype.handleRequestError = function (model, data, name, visitorId) {
        var actualVisitorId = visitorId || model.get(this.CURRENT_POLLING_MODEL_LOCATION + '.data.visitorId');
        this.setRequestState(model, {error: true}, name, actualVisitorId);
    };

    lpBaseInfoController.prototype.setRequestState = function (model, state, name, visitorId) {
        if (visitorId) {
            model.set(name + '.' + visitorId + '.state', state);
        } else {
            model.set(name + '.state', state);
        }
        if (model.get(this.CURRENT_POLLING_MODEL_LOCATION)) {
            updateDataObjectToModelIfAllServicesReturned({model: model, serviceName: name, state: state});
        }
    };

    lpBaseInfoController.prototype.addToVisitorInfoById = function (model, name, value, visitorId, dataObject, serviceName) {
        var idField = 'id';
        var id;
        if (visitorId) {
            addToVisitorInfoBySecondPhaseId({model: model, name: name, value: value, visitorId: visitorId, secondPhaseIdField: idField, serviceName: serviceName});
        }
    };

    lpBaseInfoController.prototype.addDataObjectToVisitorInfo = function (model, data, serviceName, dataObject,state) {
        updateCurrentPollingInfo({data: data, model: model, serviceName: serviceName});
        if (model.get(this.CURRENT_POLLING_MODEL_LOCATION)) {
            if(state && state === 'error') {
                this.setRequestState(model, {error: true}, serviceName, model.get(this.CURRENT_POLLING_MODEL_LOCATION + '.data.visitorId'));
            } else {
                this.setRequestState(model, {success: 'ok'}, serviceName, model.get(this.CURRENT_POLLING_MODEL_LOCATION + '.data.visitorId'));
            }

        }
    };

    /**
     * Adds a service to the requested services, and creates a timeout for when the requests expire.
     * @param serviceName {string} The name of the service
     * @param dataObject {*} The data object which contains the returned data & the requested & returned services
     * @param model {*} The model
     */
    lpBaseInfoController.prototype.addServiceToRequestedServices = function (serviceName, dataObject, model) {
        if (model.get(this.CURRENT_POLLING_MODEL_LOCATION + '.requestedServices')) {
            model.modify(this.CURRENT_POLLING_MODEL_LOCATION + '.requestedServices', serviceName);
        }
        if (model && model.get(this.CURRENT_POLLING_MODEL_LOCATION) && !model.get(this.CURRENT_POLLING_MODEL_LOCATION + '.timeout')) {
            var timeout = setTimeout(function(){
                requestsTimedOut({model: model, timeout: timeout});
            }, this.REQUEST_TIMEOUT);
            model.set(this.CURRENT_POLLING_MODEL_LOCATION + '.timeout', timeout);
        }
    };

    lpBaseInfoController.prototype.createEmptySharedDataObject = function(visitorId, requestedServices) {
        return {
            // data is what will eventually be written to the model
            data: {visitorId: visitorId},
            returnedServices: {},
            requestedServices: requestedServices || [],
            // A priority map determining which services we prefer to update the named properties
            // If a property isn't named in this map - any service can update it
            priority: {
                ipv4: this.serviceNames.visitMonitoring,
                pages: this.serviceNames.visitMonitoring,
                country: this.serviceNames.visitMonitoring,
                geoCity: this.serviceNames.visitMonitoring,
                geoState: this.serviceNames.visitMonitoring,
                countryCode: this.serviceNames.visitMonitoring,
                organization: this.serviceNames.visitMonitoring,
                isp: this.serviceNames.visitMonitoring,
                skill: this.serviceNames.agentSessionVisit,
                visitorName: this.serviceNames.agentSessionVisit,
                browser: this.serviceNames.visitMonitoring,
                operatingSystem: this.serviceNames.visitMonitoring,
                chatState: this.serviceNames.agentSessionVisit
            }
        };
    };

    lpBaseInfoController.prototype.createCommonInfoDataObject = function (data, visitorId, toReturn) {
        var returnData = toReturn || {};
        returnData.visitorId = visitorId;
        if (data) {
            for (var propertyName in data) {
                if (data.hasOwnProperty(propertyName)) {
                    switch (propertyName) {
                        case 'appSrvId': returnData.appServerVisitorId = data.appSrvId; break;
                        case 'identifier': returnData.visitorName = data.identifier; break;
                        case 'contactID': returnData.visitorName = data.contactID; break;
                        case 'os': returnData.operatingSystem = data.os; break;
                        case 'sso': if (data.sso && (typeof data.sso !== 'string' || data.sso !== 'false')) {returnData.sso = data.sso;} break;
                        case 'ip': returnData.ipv4 = data.ip; break;
                        case 'ipAddress': returnData.ipv4 = data.ipAddress; break;
                        case 'state':
                            var key = 'LEWebAgent.STATE_' + data.state;
                            if (agentLEManager.hasLETranslationKey(key)) {
                                returnData.chatState = agentLEManager.translateLE(key);
                            }
                            break;
                        case 'geoCountry': returnData.country = data.geoCountry; break;
                        case 'city': returnData.geoCity = data.city; break;
                        case 'geoOrg': returnData.organization = data.geoOrg; break;
                        case 'geoISP': returnData.isp = data.geoISP; break;
                        case 'displayName': returnData.agentName = data.displayName; break;
                        case 'rtSessionId' : returnData.engagementId = data.rtSessionId; returnData.rtSessionId = data.rtSessionId; break;
                        case 'pages': returnData.pages = this.handlePages(data.pages, this.defaultPageTransformer); break;
                        case 'chatAcceptTime':
                        case 'chatRequestTime':
                        case 'deviceFamily':
                        case 'sessionId':
                        case 'accountId':
                        case 'agentId':
                        case 'agentNickName':
                        case 'spectatedEngagement':
                        case 'acceptedEngagement':
                        case 'skill':
                        case 'browser':
                        case 'operatingSystem':
                        case 'visitStartTime':
                        case 'country':
                        case 'geoCity':
                        case 'geoState':
                        case 'countryCode':
                        case 'organization':
                        case 'isp':
                        case 'agentGroupName':
                        case 'sessionStartTime':
                        case 'engagementStartTime':
                            returnData[propertyName] = data[propertyName];
                            break;
                        default:
                            break;
                    }
                }
            }

            if (returnData.engagementStartTime && returnData.chatAcceptTime) {
                returnData.waitTime = lpTag.WebAgent.logicController.getFormatDurationTime(returnData.chatAcceptTime - returnData.engagementStartTime);
            }
            returnData.isMessaging = lpTag.WebAgent.logicController.isVisitorAsyncMessaging(visitorId);
        }
        return returnData;
    };

    lpBaseInfoController.prototype.handlePages = function (pages, transformer) {
        if (pages.constructor !== Array) {
            pages = [pages];
        }
        return handlePages(pages, transformer);
    };

    lpBaseInfoController.prototype.defaultPageTransformer = function(page) {
        var startTime, title, url;
        if (page) {
            startTime = page.startTime || page.pageLastAccessTime;
            title = page.title || page.pageTitle;
            url = page.url || page.pageUrl;
        }
        return {
            startTime: startTime,
            title: title,
            url: url
        };
    };

/////////////////////////////////// PRIVATE METHODS ///////////////////////////////////


    function handlePages(pages, transformer) {
        var transformed, sorted, reduced;
        transformed = transformPages(pages, transformer);
        sorted = sortPagesByTimeDesc(transformed);
        reduced = removeRefreshesFromPageList(sorted);
        return reduced;
    }

    function transformPages(pages, transformer) {
        return _.map(pages, function (val, key, col) {
            var transformed = transformer(val);
            // ensure no expected property keys are missing to unify the interface
            return _.merge({
                url: null,
                link: null,
                title: null,
                sections: null,
                startTime: null
            }, transformed);
        });
    }

    function sortPagesByTimeDesc(transformedPages) {
        var sortingKey;
        if (transformedPages && transformedPages.length > 1) { // skip sorting if size is 1 (already sorted)
            sortingKey = "startTime";
            transformedPages.sort(lpUtils.getSortFunctionWithDirection(sortingKey, -1));
        }
        return transformedPages;
    }

    function removeRefreshesFromPageList(sortedPages) {
        return _.uniq(sortedPages, true, function(item) {
            return item.url;
        });
    }


    function updateDataObjectToModelIfAllServicesReturned(data) {
        var model, dataObject, serviceName, state;
        if (data) {
            model = data.model;
            dataObject = getFromCurrentPolling(model);
            serviceName = data.serviceName;
            state = data.state;
        }
        if (model && dataObject && dataObject.returnedServices && dataObject.requestedServices && dataObject.data) {
            if (serviceName) {
                modifyCurrentPolling(model, '.returnedServices.' + serviceName, state || true);
            }
            var hasErrors = false;
            var allErrors = true;
            for (var id = 0; id < dataObject.requestedServices.length; id++ ) {
                if (!getFromCurrentPolling(model, '.returnedServices.' + dataObject.requestedServices[id])) {
                    return;
                }
                if (getFromCurrentPolling(model, '.returnedServices.' + dataObject.requestedServices[id] + '.error')) {
                    hasErrors = true;
                } else {
                    allErrors = false;
                }
            }
            var status = 'success';
            if (hasErrors) {
                if (allErrors) {
                    status = 'error';
                } else {
                    status = 'partial';
                }
            }
            addCurrentPollingDataToInfoModel(model, status);
        }
    }

    /**
     * Called when the requests time out. Checks which requests haven't returned - and marks them as returned in an
     * error state. This results in writing the data & state to the model, which results in showing either partial data
     * or an error message.
     * @param data {{model: {}, timeout: *}} Contains the the model and the timeout
     */
    function requestsTimedOut(data) {
        var model, timeout, dataObject;
        if (data) {
            model = data.model;
            timeout = data.timeout;
            dataObject = getFromCurrentPolling(model);
        }
        if (model && dataObject && dataObject.requestedServices && timeout === dataObject.timeout) {
            var unansweredRequests = [];
            for (var id = 0; id < dataObject.requestedServices.length; id++ ) {
                if (!getFromCurrentPolling(model, '.returnedServices.' + dataObject.requestedServices[id])) {
                    unansweredRequests.push(dataObject.requestedServices[id]);
                }
            }
            for (var index = 0; index < unansweredRequests.length; index++ ) {
                lpBaseInfoController.prototype.handleRequestError(model, null, unansweredRequests[index], null, dataObject);
            }
        }
    }

    function updateExistingVisitInfo(param) {
        var data, existingData, splitSession;
        if (param) {
            data = param.data;
            existingData = param.existingData;
            splitSession = param.splitSession;
        }
        if (data && existingData) {
            var visitorId = data.visitorId;
            if (visitorId) {
                if (splitSession && splitSession.keys && splitSession.data) {
                    var isSplitSession = false;
                    for (var index = 0; index < splitSession.keys.length; index++) {
                        var keyProperty = splitSession.keys[index];
                        if (data[keyProperty] && existingData[keyProperty] && data[keyProperty] !== existingData[keyProperty]) {
                            isSplitSession = true;
                            break;
                        }
                    }
                    if (isSplitSession) {
                        var splitSessionData = {};
                        for(var dataIndex = 0; dataIndex < splitSession.data.length; dataIndex++) {
                            var dataProperty = splitSession.data[dataIndex];
                            if (existingData[dataProperty]) {
                                splitSessionData[dataProperty] = existingData[dataProperty];
                            }
                        }
                        existingData.splitSession = splitSessionData;
                    }
                }
                for (var name in data) {
                    if (data.hasOwnProperty(name)) {
                        existingData[name] = data[name];
                    }
                }
            }
        }
    }

    function updateCurrentPollingInfo(param) {
        var data, model, serviceName, priority, existingData, requestedServices, returnedService;
        if (param) {
            data = param.data;
            model = param.model;
            serviceName = param.serviceName;
            priority = getFromCurrentPolling(model, '.priority');
            existingData = getFromCurrentPolling(model, '.data');
            requestedServices = getFromCurrentPolling(model, '.requestedServices');
        }
        if (data && requestedServices) {
            for (var name in data) {
                if (data.hasOwnProperty(name)) {
                    // The new value is added to the existing data in one of the following scenarios:
                    // * We didn't specify a priority or service name
                    // * There isn't an existing value for this property name
                    // * The priority doesn't contain this property name (any service can update it)
                    // * The priority contains this property name - but the given service name hasn't returned yet
                    // * The priority contains this property name - but the given service returned with an error
                    // * The priority contains this property name - and gives the current service name
                    // In this way - the priority map allows us to determine which services are allowed to update certain values
                    returnedService = getFromCurrentPolling(model, '.returnedServices.' + priority[name]);
                    if (!priority || !serviceName || !existingData[name] || !priority.hasOwnProperty(name) || !returnedService || returnedService.error || priority[name] === serviceName) {
                        modifyCurrentPolling(model, '.data.' + name, data[name]);
                    }
                }
            }
        }
    }

    function addCurrentPollingDataToInfoModel(model, status) {
        if (model) {
            var data = getFromCurrentPolling(model, '.data');
            if (isEmptyDataObject(data.engagement) && data.visitorBehavior) {
                delete data.visitorBehavior;
            }
            if (isEmptyDataObject(data.campaign)) {
                if (data.goal) {
                    delete data.goal;
                }
                if (data.visitorProfile) {
                    delete data.visitorProfile;
                }
            }
            var visitorId = data.visitorId;
            if (visitorId) {
                var modelPath = 'participants.info.' + visitorId + '.data';
                var existingData = lpUtils.cloneObject(model.get(modelPath)) || {};
                updateExistingVisitInfo({data: data, existingData: existingData, splitSession: {keys: ['sessionId', 'visitSessionKey'], data: ['customVariables']}});
                model.set(modelPath, existingData);
                if (status) {
                    model.modify('participants.info.' + visitorId + '.state', status);
                }
            }
            // We remove the currently polled visitor from the model.
            // This lets the lpVisitorInfoController know that we can poll the next visitor.
            model.removeKey(lpBaseInfoController.prototype.CURRENT_POLLING_MODEL_LOCATION);
        }
    }

    /**
     * returns true if an object has a single field named id
     * @param {*} object
     */
    function isEmptyDataObject(object) {
        return _.size(object) === 1 && _.has(object, 'id');
    }

    function addToVisitorInfoBySecondPhaseId(data) {
        var model, name, value, visitorId, secondPhaseIdField, dataObject, serviceName;
        if (data) {
            model = data.model;
            name = data.name;
            value = data.value;
            visitorId = data.visitorId;
            secondPhaseIdField = data.secondPhaseIdField;
            dataObject = getFromCurrentPolling(model);
            serviceName = data.serviceName;
        }
        if (name && visitorId && secondPhaseIdField && dataObject && dataObject.requestedServices) {
            // We're in the second phase - and we're adding data according to the data's ID, and the visitor ID.
            // We only want to overwrite the data that has this ID
            var existingData;
            if (dataObject && dataObject.data && dataObject.data.visitorId && dataObject.data.visitorId == visitorId) {
                var nameSplit = name.split('.');
                if (nameSplit.length == 2) {
                    existingData = (dataObject.data[nameSplit[0]] && dataObject.data[nameSplit[0]][nameSplit[1]]) || {};
                }
                else {
                    existingData = dataObject.data[name] || {};
                }
            } else if (model) {
                existingData = model.get('participants.info.' + visitorId + '.data.' + name);
            }
            if (existingData && existingData.constructor === Array) {
                // If it's in an array - overwrite the member of the array that has the same ID
                for (var index = 0; index < existingData.length; index++) {
                    if (existingData[index] && existingData[index][secondPhaseIdField] && existingData[index][secondPhaseIdField] == value[secondPhaseIdField]) {
                        modifyCurrentPolling(model, '.data.' + name, [value], secondPhaseIdField);
                    }
                }
            } else if (existingData && existingData[secondPhaseIdField] && existingData[secondPhaseIdField] == value[secondPhaseIdField]) {
                // If it's not in an array - we overwrite the sub-object with the same ID
                setCurrentPolling(model, '.data.' + name, value);
            }
            lpBaseInfoController.prototype.setRequestState(model, {success: 'ok'}, serviceName, visitorId , dataObject);
        }
    }

    function getFromCurrentPolling(model, path) {
        var endPath = path || '';
        return model.get(lpBaseInfoController.prototype.CURRENT_POLLING_MODEL_LOCATION + endPath);
    }

    function modifyCurrentPolling(model, path, value, arrayUniqueId) {
        var endPath = path || '';
        model.modify(lpBaseInfoController.prototype.CURRENT_POLLING_MODEL_LOCATION + endPath, value, arrayUniqueId);
    }

    function setCurrentPolling(model, path, value) {
        var endPath = path || '';
        model.set(lpBaseInfoController.prototype.CURRENT_POLLING_MODEL_LOCATION + endPath, value);
    }

    return lpBaseInfoController;

});
